import { PaymentMethod } from 'constants/payment';
import { useTranslation } from 'hooks/useTranslation';
import styles from './PaymentFormStep2.module.scss';

type Props = {
  formData: Record<string, string>;
  method: string;
};

const PaymentFormStep2 = ({ formData, method }: Props): JSX.Element => {
  const { t } = useTranslation();
  const { confirmDetailsLabel, confirmDetailsValue } = styles;

  return (
    <div>
      <p className={styles.headline}>
        {t('referAFriend.rewardForm.confirmDetails.headline')}
      </p>
      <p className={styles.description}>
        {t('referAFriend.rewardForm.confirmDetails.description')}
      </p>
      <div className={styles.confirmDetailsWrapper}>
        {method === PaymentMethod.BANK ? (
          <>
            <p className={confirmDetailsLabel}>
              {t('referAFriend.rewardForm.accountHolderName')}
            </p>
            <p className={confirmDetailsValue}>
              {formData['accountHolderName']}
            </p>
            <p className={confirmDetailsLabel}>
              {t('referAFriend.rewardForm.iban')}
            </p>
            <p className={confirmDetailsValue}>{formData['iban']}</p>
            <p className={confirmDetailsLabel}>
              {t('referAFriend.rewardForm.bic')}
            </p>
            <p className={confirmDetailsValue}>{formData['bic']}</p>
          </>
        ) : (
          <>
            <p className={confirmDetailsLabel}>
              {t('referAFriend.rewardForm.paypalPayment')}
            </p>
            <p className={confirmDetailsLabel}>
              {t('referAFriend.rewardForm.accountHolderName')}
            </p>
            <p className={confirmDetailsValue}>
              {formData['accountHolderName']}
            </p>
            <p className={confirmDetailsLabel}>
              {t('referAFriend.rewardForm.paypalEmail')}
            </p>
            <p className={confirmDetailsValue}>{formData['paypalEmail']}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentFormStep2;
